import { Alert, Badge, Button, Divider, Form, Input, InputNumber, Modal, Radio, Select, Spin, Tag } from 'antd';
import 'moment/locale/es';
import { useState } from 'react';
import { DeleteOutlined, FolderOpenFilled, GlobalOutlined, InfoCircleOutlined, ShopFilled } from '@ant-design/icons';
import { customRequest } from '../../../../../common/request/customRequest';
import { STATUS_CODE } from '../../../../../common/constants/statusCode';
import { useAuth } from '../../../../../store/AuthContext/AuthContext';
import { Batch, BatchView, Term } from '../entity/TermUtils';
import { getLocalHourFromUtcHour, getUtcHourFromLocalHour } from '../entity/TimezoneUtils';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

export const NewGeogridBatchModal = (props: {keyword: any, onFinish: any, onClose: any}) => {
	
	let batch = props.keyword.batch;
	
	const [form] = Form.useForm();
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState(false);	
	const [type, setType] = useState(batch ? batch.schedule_type : 'monthly');
	const days = Array.from({ length: 31 }, (_, i) => i + 1);
	const hours = Array.from({ length: 24 }, (_, i) => i + 1);
	const { projectGroup } = useAuth();
	const { t } = useTranslation();	

	const deleteBatch = async (): Promise<void> => {

		const data = {
			keyword: props.keyword.term,
			scope: props.keyword.scope,
			domain: props.keyword.domain,
			groupId: props.keyword.groupId,
			locationId: props.keyword.locationId
        };

        const response = await customRequest(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/geogrid/batch`, { method: 'DELETE', data: data });
		
		if (response?.statusCode === STATUS_CODE.BAD_REQUEST) {			
			setErrorMessage(response.message)			
		} else {
			props.onFinish();
			//console.log("NewGeogridBatchModal + onFinish");
		}	
		setIsLoading(false);	
        }    

	const initValues = batch ? 
		batch.schedule_type === 'weekly' ?
			{
				distance: batch.distance, 
				grid: batch.grid, 
				schedule_type: batch.schedule_type, 
				schedule_days_of_week: batch.schedule_days_of_week ? batch.schedule_days_of_week : null,
				schedule_hours: batch.schedule_hours ? batch.schedule_hours.map((hour: number) => getLocalHourFromUtcHour(hour)) : null			
			} 
			:
			{
				distance: batch.distance, 
				grid: batch.grid, 
				schedule_type: batch.schedule_type, 
				schedule_days_of_month: batch.schedule_days_of_month ? batch.schedule_days_of_month : null,
				schedule_hours: batch.schedule_hours ? batch.schedule_hours.map((hour: number) => getLocalHourFromUtcHour(hour)) : null			
			}
		: 
		{
			distance: 1000, 
			grid: 2, 
			schedule_type: 'monthly'
		}
	
	const onFormFinish = async (values: any) => {
		
		const data = {
			...values,
			keyword: props.keyword.term,
			scope: props.keyword.scope,
			domain: props.keyword.domain,
			groupId: props.keyword.groupId,
			locationId: props.keyword.locationId,
			schedule_hours: values.schedule_hours.map((h: number)  => getUtcHourFromLocalHour(h))
        };

		setIsLoading(true);
		const response = await customRequest(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/geogrid/batch`, { method: 'POST', data: data });
		
		if (response?.statusCode === STATUS_CODE.BAD_REQUEST) {			
			setErrorMessage(response.message)			
		} else {
			props.onFinish();
		}	
		setIsLoading(false);	
	}			 	

	return (
		<>
		<Modal open={true} onOk={() => form.submit()} onCancel={props.onClose} afterClose={form.resetFields}>

			<div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
				<div>
					{batch ? 
						<h2 style={{marginBottom:'0px'}}>Editar Programación</h2>
						:
						<h2 style={{marginBottom:'0px'}}>Crear Programación</h2>
					}
					
				</div>
				<Term keyword={props.keyword}/>
			</div>			
			<div style={{display:'flex', justifyContent:'space-between', gap:'10px'}}>								
				<BatchView kw={props.keyword}/>
				{batch && <Button shape='round' size='small' type='link'
					onClick={() => {
						Modal.confirm({
							title: '¿Confirmas que quieres eliminar la programación actual?',
							okText: t('dictionary.confirm'),
							cancelText: t('dictionary.cancel'),
							onOk: () => deleteBatch()
						})
					}}>
					<DeleteOutlined/> Borrar Programación
				</Button>}
				
			</div>
			{batch && 	<small style={{color:'silver'}}>
							{BATCH_STATUS[batch.status]}		
						</small>
			}
			<Divider/>
			{ props.keyword.scope !== 'LOCAL' && <Alert type='warning' message={<>{KW_SCOPE_WARNING[props.keyword.scope].name}</>} banner></Alert>}
			<Form layout='vertical' form={form} onFinish={onFormFinish} initialValues={initValues}>
				{/*<Divider orientation='right' style={{color:'steelblue'}}><small>CONFIGURACIÓN DEL GRID</small></Divider>	*/}
				<Form.Item
					rules={[{ required: true, message:'Por favor, ingrese la distance en metros' }]}					
					name='distance'
					label='Distancia'>		        
            		<InputNumber controls={true} addonAfter="mts" min={500} max={100000} step={100} />
				</Form.Item>
				<Form.Item name='grid' label="Dimensión del grid">
					<Radio.Group>
						<Radio value={2}> 5x5 </Radio>
						{/*<Radio value={3}> 7x7 </Radio>
						<Radio value={4}> 9x9 </Radio>
						<Radio value={5}> 11x11 </Radio>
						<Radio value={6}> 13x13 </Radio>*/}
					</Radio.Group>
				</Form.Item>
				{/*<Divider orientation='right' style={{color:'steelblue'}}><small>PROGRAMACIÓN</small></Divider>	*/}
				<Form.Item name='schedule_type' label="Frecuencia de ejecución">
					<Radio.Group onChange={(obj: any) => { setType(obj.target.value) }} value={'monthly'}>		
						{/*<Radio value='weekly'> Semanal </Radio>*/}
						<Radio value='monthly'> Mensual </Radio>						
					</Radio.Group>
				</Form.Item>
				{type === 'weekly' &&
					<Form.Item					
						name="schedule_days_of_week" 
						label="Días de la semana">						
						<Select mode='multiple'>
							<Select.Option value={1}>Lunes</Select.Option>
							<Select.Option value={2}>Martes</Select.Option>
							<Select.Option value={3}>Miércoles</Select.Option>
							<Select.Option value={4}>Jueves</Select.Option>
							<Select.Option value={5}>Viernes</Select.Option>
							<Select.Option value={6}>Sábado</Select.Option>
							<Select.Option value={0}>Domingo</Select.Option>
						</Select>
					</Form.Item>
				}
				{type === 'monthly' &&
					<Form.Item					
						name="schedule_days_of_month" 
						label="Días del mes">
						<Select mode='multiple'>
							{days.map((day) => (
								<Select.Option value={day}>{day}</Select.Option>
							))}							
						</Select>
					</Form.Item>			
				}					
				<Form.Item					
						name="schedule_hours" 
						label={<>Horas de ejecución <b style={{marginLeft:'10px'}}> {Intl.DateTimeFormat().resolvedOptions().timeZone}</b></>}>
					<Select mode='multiple'>
						{hours.map((hour) => (
							<Select.Option value={hour}>{hour}:00</Select.Option>
						))}							
					</Select>
				</Form.Item>	
			</Form>			
			<i>{batch?.lastExecution && <small style={{color:'grey'}}>Última ejecución: {moment.utc(batch.lastExecution).local().format('ll')}</small>}</i>
			<div style={{display:'flex', justifyContent:'center'}}><Spin size='large' spinning={isLoading}/></div>
			{errorMessage && <b><Alert type='warning' showIcon={true} message={errorMessage}/></b>}			
		</Modal>
		</>
	)
}

export const KW_SCOPE_WARNING: any = {
    "DOMAIN": {icon: <GlobalOutlined/>, name: "Afecta a todos los locales del dominio"},  
    "GROUP": {icon: <FolderOpenFilled />, name: "Afecta a todos los locales del grupo"},  
    "LOCAL": {icon: <ShopFilled />, name: ""},  
}

export const BATCH_STATUS: any = {
	
	"PROCESSING": "Procesando paso 1/2",  
	"COLLECTING": "Procesando paso 2/2",  
	"": ""   
  }